/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */
import { PropsWithChildren, ComponentProps } from 'react';
import styled from 'styled-components';
import {
  desktopContentSidePaddings,
  mobileContentSidePaddings,
  getDownMedia,
  maxAccountAndInvoicesInnerContentWidth,
} from '../../styles';
import { AppPageContentWrapper as DefAppPageContentWrapper } from '../../styled';

export type ContentBlockProps = PropsWithChildren<
  ComponentProps<typeof Wrapper>
>;

const ContentBlock = ({ children, ...props }: ContentBlockProps) => (
  <Wrapper {...props}>
    <div>{children}</div>
  </Wrapper>
);

const Wrapper = styled(DefAppPageContentWrapper)<{
  $sameVerticalPaddings?: boolean;
}>`
  padding-bottom: ${({ $sameVerticalPaddings }) =>
    $sameVerticalPaddings ? 37 : 62}px;

  & + & {
    margin-top: ${desktopContentSidePaddings}px;
  }

  ${getDownMedia('md')} {
    & + & {
      margin-top: ${mobileContentSidePaddings}px;
    }
  }

  ${getDownMedia('sm')} {
    padding-bottom: 52px;
  }

  > div {
    max-width: ${maxAccountAndInvoicesInnerContentWidth}px;
  }
`;

export { ContentBlock };
